module.exports = __webpack_public_path__ + "static/media/email-settings-03.aa709c62.png";